"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDateTimeStr = exports.toDateTimeLocal = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const InputFloatButtons_1 = require("../Util/InputFloatButtons");
const useInputValueControl_1 = require("../../hooks/useInputValueControl");
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const Button_1 = __importDefault(require("../Util/Button"));
const Input_1 = __importDefault(require("./Base/Input"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const ten = (i) => (i < 10 ? '0' : '') + i;
/* Removes the Zulu, date time does not want zulu.. */
function toDateTimeLocal(date) {
    const YYYY = date.getFullYear();
    const MM = ten(date.getMonth() + 1);
    const DD = ten(date.getDate());
    const HH = ten(date.getHours());
    const II = ten(date.getMinutes());
    const SS = ten(date.getSeconds());
    return `${YYYY}-${MM}-${DD}T${HH}:${II}:${SS}`;
}
exports.toDateTimeLocal = toDateTimeLocal;
// datetime-local does not want any zulu specifying.
function toDateTimeStr(utcZuluStr) {
    if (!utcZuluStr) {
        return '';
    }
    // ensure this is a utc zulu str, if its not zulu, the date will not properly warp to the users TZ.
    return toDateTimeLocal(new Date(utcZuluStr));
}
exports.toDateTimeStr = toDateTimeStr;
const DateInput = (props) => {
    var _a;
    const { nullable } = props;
    let value = useInputForm_1.useInputValue(props);
    const type = (_a = props.type) !== null && _a !== void 0 ? _a : 'datetime-local';
    if (type === 'datetime-local') {
        value = toDateTimeStr(value);
    }
    else if (type === 'date') {
        value = helpers_1.toDateStr(value);
    }
    const inputRef = react_1.useRef();
    const setInputValue = useInputValueControl_1.useInputValueControl(inputRef);
    const onClearClick = react_1.useCallback((e) => {
        setInputValue(null);
    }, [setInputValue]);
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [inputRef]);
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(InputLabel_1.default, { className: "retracted" }),
        react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className']), { value: value, ref: forwardedRef, type: type })),
        nullable && value !== '' && (react_1.default.createElement(InputFloatButtons_1.InputFloatButtons, { className: "j-date-input-clear-wrap" },
            react_1.default.createElement(Button_1.default, { className: "j-date-input-clear-button", onClick: onClearClick }, "X"))),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-date-input', DateInput);
